import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { cn } from "@/lib/utils";
import { useTaal } from "@/contexts/TaalContext";
import { metAgent, passendeAgenten } from "@/lib/agentmenu";

/** AT, @-agents: het menu achter @ in het invoerveld. De lijst wordt een keer opgehaald, bij de
 *  eerste @; daarna filtert hij op wat er getypt wordt. */
export function useAgentMenu(input, setInput) {
  const [agenten, setAgenten] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dicht, setDicht] = useState(false);
  const wil = (input || "").startsWith("@");

  useEffect(() => {
    if (!wil || agenten !== null) return undefined;
    let weg = false;
    axios.get(`${API}/agents`)
      .then((r) => { if (!weg) setAgenten(Array.isArray(r?.data) ? r.data : []); })
      .catch(() => { if (!weg) setAgenten([]); });
    return () => { weg = true; };
  }, [wil, agenten]);

  const visible = agenten === null ? null : passendeAgenten(input, agenten);
  const open = !dicht && visible !== null;

  const onChange = () => { setDicht(false); setActiveIndex(0); };
  const select = (agent) => {
    if (!agent) return;
    setInput(metAgent(agent));
    setActiveIndex(0);
  };
  const onKeyDown = (e) => {
    if (!open || !visible.length) return false;
    if (e.key === "ArrowDown") { e.preventDefault(); setActiveIndex((i) => (i + 1) % visible.length); return true; }
    if (e.key === "ArrowUp") { e.preventDefault(); setActiveIndex((i) => (i - 1 + visible.length) % visible.length); return true; }
    if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); select(visible[activeIndex]); return true; }
    if (e.key === "Escape") { e.preventDefault(); setDicht(true); return true; }
    return false;
  };
  return { open, visible: visible || [], activeIndex, setActiveIndex, onChange, onKeyDown, select };
}

export default function AgentMenu({ menu }) {
  const { t } = useTaal();
  if (!menu?.open) return null;
  return (
    <div className="absolute bottom-full left-0 right-0 mb-2 bg-popover border rounded-xl shadow-lg overflow-hidden z-20 max-h-72 overflow-y-auto"
         data-testid="agent-menu">
      <div className="px-3 pt-2 pb-1 text-[11px] uppercase tracking-wide text-muted-foreground">{t("Agenten")}</div>
      {menu.visible.length === 0 ? (
        <div className="px-3 py-2 text-sm text-muted-foreground">{t("Geen passende agent")}</div>
      ) : menu.visible.map((a, i) => (
        <button key={a.id} type="button" onMouseEnter={() => menu.setActiveIndex(i)} onClick={() => menu.select(a)}
                data-testid="agent-optie"
                className={cn("w-full text-left px-3 py-2 text-sm flex flex-col transition-colors",
                              i === menu.activeIndex ? "bg-[hsl(var(--accent))]/10" : "hover:bg-muted/50")}>
          <span className="font-medium">@{a.name}</span>
          {a.standing_task && <span className="text-xs text-muted-foreground break-words">{a.standing_task}</span>}
        </button>
      ))}
    </div>
  );
}
